import { UrnDefinition } from '.';
import { UrnType } from './enums';

/**
 * The attachment object.
 * @export
 * @interface Attachment
 */
export interface Attachment {
  /**
   * The ID of the attachment.
   * @type {string}
   * @memberof Attachment
   */
  id?: string;
  /**
   * The id of the RFI related to the attachment (uuid)
   * @type {string}
   * @memberof Attachment
   */
  rfiId?: string;
  /**
   * The timestamp of the date and time the attachment was created, in the following format: ``YYYY-MM-DDThh:mm:ss.sz``.
   * @type {Date}
   * @memberof Attachment
   */
  createdAt?: Date;
  /**
   * The last time the attachment attributes were updated, in the following format: ``YYYY-MM-DDThh:mm:ss.sz``.
   * @type {Date}
   * @memberof Attachment
   */
  updatedAt?: Date;
  /**
   * The ID of the user who created the attachment.
   * @type {string}
   * @memberof Attachment
   */
  createdBy?: string;
  /**
   * The timestamp of the date and time the attachment was deleted, in the following format: ``YYYY-MM-DDThh:mm:ss.sz``. This is only relevant for deleted attachments.
   * @type {Date}
   * @memberof Attachment
   */
  deletedAt?: Date;
  /**
   * The ID of the user who deleted the attachment. This is only relevant for deleted attachments.
   * @type {string}
   * @memberof Attachment
   */
  deletedBy?: string;
  /**
   * The name of the attachment.
   * @type {string}
   * @memberof Attachment
   */
  name?: string;
  /**
   * The URL of the storage location for the attachment.
   * @type {string}
   * @memberof Attachment
   */
  url?: string;
  /**
   *
   * @type {UrnDefinition}
   * @memberof Attachment
   */
  urn?: UrnDefinition;
  /**
   * The type of attachment urn.
   * @type {string}
   * @memberof Attachment
   */
  urnType?: UrnType;
  /**
   * The type of attachment.
   * @type {string}
   * @memberof Attachment
   */
  attachmentType?: AttachmentType;
  /**
   *
   * @type {AttachmentPermittedActions}
   * @memberof Attachment
   */
  permittedActions?: AttachmentPermittedActions;
}

/**
 * @export
 * @enum {string}
 */
export enum AttachmentType {
  Photo = 'photo',
  Document = 'document',
}

/**
 * actions that are permitted for the current user on the attachment.
 * @export
 * @interface AttachmentPermittedActions
 */
export interface AttachmentPermittedActions {
  /**
   * can the current user delete this attachment
   * @type {boolean}
   * @memberof AttachmentPermittedActions
   */
  removeAttachment?: boolean;
}
